import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { NavLink } from 'react-router-dom';

const Navigation = ({ user, onSignOut }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isAuthPage, setIsAuthPage] = useState(false);
  const [isVerificationPage, setIsVerificationPage] = useState(false);

  useEffect(() => {
    const authPages = ['/signin', '/signup'];
    const verificationPages = ['/confirm-signup'];
    
    setIsAuthPage(authPages.includes(location.pathname) || location.pathname.startsWith('/confirm-signup/'));
    setIsVerificationPage(verificationPages.includes(location.pathname) || location.pathname.startsWith('/confirm-signup/'));
  }, [location.pathname]);

  const handleSignOut = async () => {
    await onSignOut();
    navigate('/signin');
  };

  return (
    <nav className="navbar">
      <div className="container" style={{ paddingLeft: 'var(--spacing-sm)' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 'var(--spacing-sm)'
        }}>
          <Link to="/" style={{ 
            textDecoration: 'none', 
            color: 'var(--text-color)',
            marginLeft: '0',
            flexShrink: 0
          }}>
            <Logo size={120} />
          </Link>
          {user ? (
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'flex-end', 
              gap: 'var(--spacing-xs)',
              minWidth: 'fit-content',
              flexShrink: 1,
              flex: 1
            }}>
              {user.attributes?.given_name && (
                <div style={{ 
                  color: 'var(--text-secondary)', 
                  fontSize: 'var(--font-size-sm)',
                  fontWeight: '500',
                  textAlign: 'right',
                  marginBottom: 'var(--spacing-xs)'
                }}>
                  Welcome, {user.attributes.given_name}
                </div>
              )}
              <div style={{ 
                display: 'flex', 
                gap: 'var(--spacing-xs)', 
                alignItems: 'center',
                flexWrap: 'wrap',
                justifyContent: 'flex-end',
                minWidth: 0,
                width: '100%'
              }}>
                <NavLink to="/sample-tests" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} style={{
                  color: 'var(--primary-color)',
                  textDecoration: 'none',
                  padding: '4px 8px',
                  borderRadius: 'var(--radius-md)',
                  transition: 'all var(--transition-normal)',
                  fontSize: 'var(--font-size-xs)',
                  fontWeight: '500',
                  whiteSpace: 'nowrap'
                }}>
                  Sample Tests
                </NavLink>
                <NavLink to="/my-tests" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} style={{
                  color: 'var(--primary-color)',
                  textDecoration: 'none',
                  padding: '4px 8px',
                  borderRadius: 'var(--radius-md)',
                  transition: 'all var(--transition-normal)',
                  fontSize: 'var(--font-size-xs)',
                  fontWeight: '500',
                  whiteSpace: 'nowrap'
                }}>
                  All Tests
                </NavLink>
                <NavLink to="/offers" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} style={{
                  color: 'var(--primary-color)',
                  textDecoration: 'none',
                  padding: '4px 8px',
                  borderRadius: 'var(--radius-md)',
                  transition: 'all var(--transition-normal)',
                  fontSize: 'var(--font-size-xs)',
                  fontWeight: '500',
                  whiteSpace: 'nowrap'
                }}>
                  Offers
                </NavLink>
                <NavLink to="/settings" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
                  style={{
                    color: 'var(--primary-color)',
                    textDecoration: 'none',
                    padding: '4px 8px',
                    borderRadius: 'var(--radius-md)',
                    transition: 'all var(--transition-normal)',
                    fontSize: 'var(--font-size-xs)',
                    fontWeight: '500',
                    whiteSpace: 'nowrap'
                  }}>
                  Settings
                </NavLink>
                <button onClick={handleSignOut} className="button secondary" style={{
                  padding: '4px 8px',
                  fontSize: 'var(--font-size-xs)',
                  whiteSpace: 'nowrap'
                }}>Sign Out</button>
              </div>
            </div>
          ) : isVerificationPage ? null : !isAuthPage && (
            <div style={{ 
              display: 'flex', 
              gap: 'var(--spacing-xs)',
              flexWrap: 'wrap',
              justifyContent: 'flex-end',
              flexShrink: 1,
              flex: 1
            }}>
              <Link to="/signin" className="button" style={{
                padding: '4px 8px',
                fontSize: 'var(--font-size-xs)',
                whiteSpace: 'nowrap'
              }}>Sign In</Link>
              <Link to="/signup" className="button secondary" style={{
                padding: '4px 8px',
                fontSize: 'var(--font-size-xs)',
                whiteSpace: 'nowrap'
              }}>Sign Up</Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
